#@import Booking.Views.PickerElement
#@import Booking.Presenters.TimeBubble
#@export Booking.Views.TimeBubble

class Booking.Views.TimeBubble extends Booking.Views.PickerElement

  presenter: Booking.Presenters.TimeBubble

  templateName: 'timebubble'

  tagName: 'li'

  events:
    'change input[type=checkbox]': 'select'

  constructor: ->
    Booking.Views.PickerElement.apply this, arguments

    @listenTo @model, 'change:selected', @render

  attributes: ->
    'class': 'time-bubble'
